import { type CSSProperties, type ComponentPropsWithoutRef } from 'react';

import MuiSkeleton from '@material-ui/lab/Skeleton';

import styles from './Skeleton.module.css';

export type SkeletonProps = Omit<
  ComponentPropsWithoutRef<'div'>,
  'children'
> & {
  height?: CSSProperties['height'];
  variant?: 'text' | 'rect' | 'circle';
  width?: CSSProperties['width'];
};

const skeletonClasses = { root: styles.root };

export const Skeleton = ({
  'aria-hidden': ariaHidden = true,
  ...props
}: SkeletonProps) => (
  <MuiSkeleton
    animation="wave"
    aria-hidden={ariaHidden}
    classes={skeletonClasses}
    {...props}
  />
);
